import React from "react";
import Section from "@/components/foundation/Section";
import RoadmapCard from "@/components/marketing/RoadmapCard";
import { AutoLinkPartners } from "@/components/marketing/PartnerLink";

const wrap = (arr) => arr.map((s) => <AutoLinkPartners key={s} text={s} />);

const PHASES = [
  {
    phase: "01",
    title: "Foundation",
    status: "live",
    features: wrap([
      "Merchant onboarding",
      "Mastercard Finicity integration",
      "ZenScore engine",
      "Funding applications",
      "Admin platform",
    ]),
  },
  {
    phase: "02",
    title: "Expansion",
    status: "in-development",
    features: [
      "Repayment monitoring",
      "ZenScore validation loops",
      "Funding partner portal",
      "Marketplace beta",
      "SaaS platform",
    ],
  },
  {
    phase: "03",
    title: "Ecosystem",
    status: "vision",
    features: [
      "Open marketplace",
      "Embedded finance",
      "Automated underwriting",
      "Partner subscriptions",
      "Capital APIs & national expansion",
    ],
  },
];

export const RoadmapSection = () => {
  return (
    <Section
      eyebrow="Roadmap"
      headline="The future of business capital."
      subheadline="Where ZenMe is today, what's shipping next, and the ecosystem we're building for the long term."
      spacing="lg"
    >
      <div
        className="grid grid-cols-1 gap-6 lg:grid-cols-3"
        data-testid="roadmap-section"
      >
        {PHASES.map((p, i) => (
          <RoadmapCard key={p.phase} {...p} index={i} />
        ))}
      </div>
    </Section>
  );
};

export default RoadmapSection;
